import axios from '@/axios'

class UserDataService {
  async getAllUsers(page: any): Promise<any> {
    return axios.get(`/users/getAllUsers?page=${page}`);
  }
  async searchUsers(query: string, page = 1): Promise<any> {
    return axios.get(`/users/search?query=${encodeURIComponent(query)}&page=${page}`);
  }
  async getUserById(id: any): Promise<any> {
    return axios.get(`/users/${id}/get`)
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/users/${id}/update`, data)
  }
  async sendNotification(data: any): Promise<any> {
    return axios.post('/users/sendNotification', data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/users/${id}/delete`)
  }
  async getUserTypes(): Promise<any> {
    return axios.get('/users/getUserTypes')
  }
  async getUserStatuses(): Promise<any> {
    return axios.get('/users/getUserStatuses')
  }
  async getFakturacneUdajeById(id: any): Promise<any> {
    return axios.get(`/users/fakturacneUdaje/${id}/get`)
  }
  async getFakturacneUdajeByUserId(userId: any): Promise<any> {
    return axios.get(`/users/fakturacneUdaje/${userId}/getAllForUser`)
  }
  async addFakturacneUdaje(data: any): Promise<any> {
    return axios.post('/users/fakturacneUdaje/add', data)
  }
  async updateFakturacneUdaje(id: any, data: any): Promise<any> {
    return axios.put(`/users/fakturacneUdaje/${id}/update`, data)
  }
}
export default new UserDataService()
